import { createSelector } from 'reselect';

const sellFromHomeHistorySelector = (state) => state.order.sellFromHomeHistory;

export const selectSellFromHomeHistory = createSelector(
  sellFromHomeHistorySelector,
  (state) => state.data,
);

export const selectSellFromHomeHistoryError = createSelector(
  sellFromHomeHistorySelector,
  (state) => state.error,
);
